import React, { Component } from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './QuickRead.css';
import * as actions from './Actions';
import { fetchInitialData } from "../fetchData";
import Right from '../right/Right';
import Service from '../service/Service';
import QuickCommentList from './common/QuickCommentList';
import User from './common/QuickUsers';
import QuickLinks from './common/QuickLinks';
import QuickContent from './common/QuickContent';
import QuickCommentOverlay from './common/QuickCommentOverlay';
import ReplyOverlay from './common/ReplyOverlay';
import UserListOverlay from './common/UserListOverlay';
import withContext from "../../withContext";

const service = new Service();
var player = {};

class QuickDetails extends Component {
    constructor(props) {
        super(props);
        let isWindow = false;
        if (__isBrowser__) {
            isWindow = true;
        }
        let quickUrl = props.location.pathname.split('/');
        let quickReadType = quickUrl[2].charAt(0).toUpperCase()+ quickUrl[2].slice(1);
        let initialData = [];
        let serverSideData = {};
        let initialCommentData = [];
        this.totalCount = 0;
        let metaTitle = quickReadType + " – " + "Planning, Pregnancy, Baby Care & Parenting | Quick Reads";
        let metaDescription = [
            { "name": "description", "content": "FirstCry Parenting provides you with quick reads that offers" + " " + quickReadType.toLowerCase() + " "+ "on planning, pregnancy, baby care & parenting to consume & share your much needed information in no time." },
            { "name": "robots", "content": "all" }
        ]
        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            serverSideData = window.__initialData__['initialData'];
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                serverSideData = props.staticContext.initialData['initialData'];

            }
        }
       // console.log("serverSideData details -- ", serverSideData);
        if (serverSideData && serverSideData['result']) {
            let Ary = [];
            Ary.push(serverSideData['result']);
            initialData = Ary;
            initialCommentData = Ary[0]['comment'];
            this.totalCount = parseInt(initialData[0]['commentCount']);
            //console.log("comment data -- ", Ary[0]['comment']);
        }
        if (initialData.length > 0) {
            // metaTitle = quickReadType + initialData[0].title + " – FirstCry Parenting";
            metaTitle = initialData[0].metaTitle;
            metaDescription = [
                { "name": "description", "content": initialData[0].metaDescription }
            ]
        }
        this.state = {
            initialData: initialData,
            commentData: initialCommentData,
            isCmtPage: false,
            metaTitle: metaTitle,
            quickReadType: quickReadType,
            metaDescription: metaDescription,
            isWindow: isWindow,
            fileLoadStatus: 'start',
        };

        this.dId = this.props.params.id;
        // console.log("id --- ", this.props.params.id);
        this.disPageNo = 1;
        if (this.props.params.page && this.props.params.page > 0) {
            this.disPageNo = parseInt(this.props.params.page);

        }
        this.maxScroll = 0;
        this.timeout = 0;
    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        var dUrl = reqUrl.split('/')[3];
        console.log("URL data", dUrl)
        var id = "";
        if (dUrl.includes('?')) {
            id = dUrl.split('?')[0].split('-').pop();
        } else {
            id = dUrl.split('-').pop();
        }
        //var url = global.api_ci_url + "QuickReads/getdiscussiondetails";

        var url = global.api_url + "discussion/getdiscussiondetails";
        var id = reqUrl.split('?')[0].split('/')[4];
        let body = JSON.stringify({
            "discussionId": id
        })
        return fetchInitialData(url, JSON.stringify(header), body);
    }

    componentDidMount() {
        var self = this;
        if (self.state.isWindow && self.state.fileLoadStatus === 'start') {
            self.setState({ fileLoadStatus: 'loading' }, () => {
                setTimeout(function () {
                    service.do_load_files(self, player);
                }, 0);
            })
        }
        document.addEventListener("click", actions.domClick);
        this.pageData = this.pageData.bind(this);
        window.addEventListener("scroll", this.pageData, false);
        if (navigator.onLine) {
            this.checkPage();
            let size = 10;
            if (this.disPageNo > 1) {
                size = 10 * this.disPageNo;
            }
            if (!this.state.initialData || (this.state.initialData && this.state.initialData.length < 1)) {

                service.showLoader();
                this.discussionData();
            } else {
                localStorage.setItem('quickreadDetails_' + this.dId, JSON.stringify(this.state.initialData)); actions.loadSliders();
            }
            if (!this.state.commentData || (this.state.commentData && this.state.commentData.length < 1)) {
                service.showLoader();
                this.commentData(1, size);
            } else {
                localStorage.setItem('quickreadComments_' + this.dId, JSON.stringify(this.state.commentData));
                localStorage.setItem('quickreadCommentsCnt_' + this.dId, JSON.stringify(this.totalCount));
            }
            actions.loadReadMore();
        } else {
            if (localStorage.getItem('quickreadDetails_' + this.dId)) {
                this.setState({ initialData: JSON.parse(localStorage.getItem('quickreadDetails_' + this.dId)) }, () => { actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });
            }
            if (localStorage.getItem('quickreadComments_' + this.dId)) {
                this.setState({ commentData: JSON.parse(localStorage.getItem('quickreadComments_' + this.dId)) }, () => { actions.loadReadMore(); });
            }
            if (localStorage.getItem('quickreadCommentsCnt_' + this.dId)) {
                this.totalCount = localStorage.getItem('quickreadCommentsCnt_' + this.dId);
            }
            service.hideLoader();
        }
        actions.setWidth();
    }

    // componentWillMount() {
    //     this.unlisten = this.props.history.listen((location, action) => {
    //         this.checkPage();

    //     });
    // }

    componentWillUnmount() {
        this.unlisten();

        window.removeEventListener("scroll", this.pageData, false);
        document.removeEventListener("click", actions.domClick);
    }

    checkPage() {
        // debugger;
        this.url = new URL(window.location.href);
        if (this.url.searchParams.get("cid")) {
            this.setState({ isCmtPage: true });
            this.cid = this.url.searchParams.get("cid");
            this.pt = this.url.searchParams.get("pt");
        } else {
            this.setState({ isCmtPage: false }, () => { actions.loadSliders(); });
            this.cid = this.dId;
            this.pt = 0;
        }
    }

    // appendURL() {
    //     if (this.state.isCmtPage) {
    //         this.props.history.push(service.getRedirectUrl("/quick-reads/t/" + this.props.params.title + "/page/" + this.disPageNo + "?cid=" + this.cid + "&pt=" + this.pt));
    //     } else {
    //         this.props.history.push(service.getRedirectUrl("/quick-reads/t/" + this.props.params.title + "/page/" + this.disPageNo));
    //     }
    // }

    pageData() {
        var _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
            if (document.getElementsByClassName('comment_container')[0]) {
                var cS = document.getElementsByClassName('comment_container')[0].offsetTop;
                var cH = document.getElementsByClassName('comment_container')[0].offsetHeight - 2000,
                    wS = window.scrollY - cS;
                if (!((window.innerHeight + window.scrollY) >= document.body.offsetHeight) && wS > cH) {
                    if (wS > _this.maxScroll && _this.totalCount > (_this.disPageNo * 10)) {
                        _this.maxScroll = wS;
                        ++_this.disPageNo;
                        service.showLoader();
                        service.showTracking();
                        _this.commentData(_this.disPageNo, 10);
                    } else {
                        return false;
                    }
                }
            }
        }, 100)
    }

    discussionData() {
        var postData = {
            "discussionId": this.dId
        }
        var url = global.api_ci_url + "QuickReads/getdiscussiondetails";
        service.postServiceCall(url, postData).then((json) => {
            if (json['result']) {
                var dataAry = [];
                dataAry.push(json['result']);
                localStorage.setItem('quickreadDetails_' + this.dId, JSON.stringify(dataAry));
                this.setState({ initialData: dataAry }, () => { service.loadImages(); actions.loadSliders(); actions.loadReadMore(); player = service.initializeVideoPlayer(this, player); });

            }
            service.hideLoader();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
        });
    }

    commentData(pageno, size) {
        // debugger;
        var postData = {
            "recordId": this.cid,
            "postType": this.pt,
            "pageno": pageno,
            "pagesize": size
        }
        var url = global.api_ci_url + "QuickReads/getcomment";
        service.postServiceCall(url, postData).then((json) => {
            // console.log("commentData --- ", json['result']);
            if (json['result'] && json['result'] != 'Record not found') {
                if (this.state.commentData.length > 0) {
                    if (size == (pageno * 10)) {
                        this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                    } else {
                        let ary = this.state.commentData;
                        this.setState({ commentData: ary.concat(json['result']) }, () => { service.loadImages(); actions.loadReadMore(); });
                    }
                    // if (parseInt(pageno) != 1) {
                    //     this.appendURL();
                    // }
                } else {
                    localStorage.setItem('quickreadComments_' + this.dId, JSON.stringify(json['result']));
                    localStorage.setItem('quickreadCommentsCnt_' + this.dId, JSON.stringify(json['totalComment']));
                    this.totalCount = parseInt(json['totalComment']);
                    this.setState({ commentData: json['result'] }, () => { service.loadImages(); actions.loadReadMore(); });
                }
            }
            service.hideLoader();
            service.hideTracking();
        }).catch((error) => {
            console.error(error);
            service.hideLoader();
            service.hideTracking();
        });
    }

    reloadData() {
        var _this = this;
        setTimeout(() => {
            service.showLoader();
            _this.discussionData();
            _this.commentData(_this.disPageNo, (_this.disPageNo * 10));
        }, 500)
    }

    render() {
        var mainDivStyle = {};
        if (this.state.isCmtPage) {
            mainDivStyle = {
                padding: 0
            }
        }
        return (
            <main className="quickread-main main-container">
                <Helmet
                    title={this.state.metaTitle}
                    meta={this.state.metaDescription}
                />
                <div className="title">
                    <div className="breadcrumb R11_9e">
                        <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span><a href={service.getRedirectUrl("/quick-reads")} className="R11_9e">Quick Reads</a></span>

                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        <span className="R11_9e">{this.state.quickReadType}</span>

                        <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                        {this.state.initialData && this.state.initialData[0] && !this.state.isCmtPage &&
                            <span>{this.state.initialData[0].title} </span>
                        }

                        {this.state.initialData && this.state.initialData[0] && this.state.isCmtPage &&
                            <span><a href={service.getRedirectUrl(`/quick-reads/${service.replaceSymbols(this.state.quickreadtype)}/${service.replaceSymbols(this.state.initialData[0].title)}/${this.state.initialData[0].discussionId}`)}>{this.state.initialData[0].title}</a></span>
                        }
                    </div>
                    {this.state.initialData && this.state.initialData[0] && !this.state.isCmtPage &&
                            <h1 id="skipToH1" tabIndex={0}>{this.state.quickReadType +":"} {this.state.initialData[0].title} </h1>
                        }
                </div>
                <div className="sub-container left">
                    <div className="data-container left">
                        {this.state.initialData && this.state.initialData.map((quickread, index) =>
                            <div key={index} className="quick-block" id={`quick-reads_${quickread.discussionId}`} style={mainDivStyle}>
                                {!this.state.isCmtPage &&
                                    <a>
                                        <User user={quickread} isAnonymus={0} eleRef={this} />
                                    </a>
                                }
                                {!this.state.isCmtPage &&
                                    <QuickContent quickread={quickread} linkUrl={quickread.discussionId} isDisLanding={true} eleRef={this} />
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line"></div>
                                }
                                {!this.state.isCmtPage &&
                                    <QuickLinks quickread={quickread} eleRef={this} />
                                   
                                }
                                {!this.state.isCmtPage &&
                                    <div className="divider_line comments_count_divider">
                                        {quickread.commentCount < 1000 ?
                                            <div className="totalComment R13_42"> {quickread.commentCount} Comments </div>
                                            :
                                            <div className="totalComment R13_42"> {Number(((quickread.commentCount) / 1000).toFixed(1))}k Comments </div>
                                        }
                                    </div>
                                }
                                {this.state.commentData &&
                                    <QuickCommentList quickread={this.state.initialData} comments={this.state.commentData} eleRef={this} />
                                }
                            </div>
                        )}
                        {(!this.state.initialData || this.state.initialData.length < 1) &&
                            <div className="quick-block"></div>
                        }
                        <div className="write-comment">
                            <label>
                                {this.state.commentData && this.state.commentData.length > 0 ?
                                    <input type="text" placeholder="Write your comment here" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, this.state.initialData[0].title, this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                    :
                                    <input type="text" placeholder="Be the first to comment" onClick={() => actions.openParticipatePopup(this.state.initialData[0].discussionId, this.state.initialData[0].title, this.state.initialData[0].discription, this.state.initialData[0].groupId, this.state.initialData[0].categoryId, this.state.initialData[0].urls && this.state.initialData[0].urls[0] ? this.state.initialData[0].urls[0].source : '')} readOnly />
                                }
                            </label>
                            <div data-icon-font="o" className="icon comment-attachment"></div>
                            <div data-icon-font="&#xe00d;" className="icon submit-comment post_comment"></div>
                        </div>
                    </div>
                </div>
                <input type="hidden" id="post_commentId" value="" />
                <input type="hidden" id="post_parentUserId" value="" />
                <input type="hidden" id="post_parentUserName" value="" />
                <input type="hidden" id="post_parentIsAnonymus" value="" />
                <input type="hidden" id="post_replyId" value="" />
                <input type="hidden" id="post_dId" value="" />
                <input type="hidden" id="post_gId" value="" />
                <input type="hidden" id="post_cId" value="" />
                <input type="hidden" id="post_dUrl" value="" />
                <QuickCommentOverlay eleRef={this} />
                <ReplyOverlay eleRef={this} />
                <UserListOverlay eleRef={this} />
                <div className="share-overlay"></div>
                <Right url={this.props.location.pathname} />
            </main>
        )
    }
}

export default withContext(QuickDetails);
